import(/* webpackMode: "eager" */ "/vercel/path0/app/blog/from-idea-to-mvp/page.tsx");
